import React, { useState, useEffect } from 'react'
import { JsonEditor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import { Button } from '../button';

export const Editor = props => {
  const [state, setState] = useState({
    value: props.value,
  });

  const setHeight = () => {
    try {
      const height = 1000;
      const node = document.querySelector('.jsoneditor');
      if (node.clientHeight < height) { 
        node.style.height = `${height}px`;
      }
    } catch (err) {}
  }

  const onChange = value => {
    setState(s => ({ ...s, value }));
    props.onChange && props.onChange(value);
    setHeight();
  }

  const onClose = () => {

  }

  const onSave = () => {
    props.onSave && props.onSave(state.value);
  }

  useEffect(() => {
    const inte = setInterval(setHeight, 500);
    
    return () => { 
      clearInterval(inte)
    }
  }, []);

  return (
    <div>
      <JsonEditor mode="code" allowedModes={['tree', 'view', 'form', 'code', 'text']} value={state.value} onChange={onChange} />
      <Button title={'Save'} onClick={onSave} />
      {props.onClose && <Button title="Close" onClick={onClose} />}
    </div>
  )
}